import { signal } from '@preact/signals';
export type Toast = { id: string; message: string; action?: { label: string; onClick: () => void }; expiresAt: number };
export const toasts = signal<Toast[]>([]);

export function showToast(message: string, action?: Toast['action'], durationMs = 5000): void {
  const id = Math.random().toString(36).slice(2);
  const expiresAt = Date.now() + durationMs;
  toasts.value = [...toasts.value, { id, message, action, expiresAt }];
  setTimeout(() => {
    toasts.value = toasts.value.filter(t => t.id !== id);
  }, durationMs);
}

export function dismissToast(id: string): void {
  toasts.value = toasts.value.filter(t => t.id !== id);
}
